<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span >{{$t('common.show')}}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{$t('common.entries')}}</span>
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <b-row>
                  <b-col>
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                        @keydown.enter.native="filterList"
                      ></b-form-input>
                    </label>
                  </b-col>
                </b-row>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :show-empty="true"
              @sort-changed="sortChange"
            >
              <template v-slot:cell(actions)="row" v-if="role_modules.some(item => item.value == 'role.edit')">
                <button class="btn2 btn2-primary btn-sm mx-1" @click="onEdit(row.item)"><i class="uil uil-edit"></i></button>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      customBtnClass="component-user"
      autoload
      centered
      yesText="Create"
      noText="Cancel"
      title="Create Information"
      ref="createRole"
      size="xl"
      :component="computedCreateComponent"
      @onYes="onCreate"
      v-if="role_modules.some(item => item.value == 'role.create')"
    />
    <Dialog
      customBtnClass="component-user"
      autoload
      centered
      yesText="Edit"
      noText="Cancel"
      title="Edit Information"
      ref="editRole"
      size="xl"
      :parameters="{ rowId }"
      :component="computedEditComponent"
      @onYes="onSave"
      v-if="role_modules.some(item => item.value == 'role.edit')"
    />
  </div>
</template>

<script>
/* import { tableData } from './data-advance' */
import { mapActions } from 'vuex'
import moment from 'moment'
import Dialog from '@components/offcanvas'
import 'moment-timezone';

export default {
  components: {
    Dialog
  },
	data() {
		return {
			title: 'Role',
			items: [],
			totalRows: 1,
			currentPage: 1,
      jobID: '',
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: 'createAt',
			sortDesc: true,
			fields: [
				{ 
          label: 'Role', 
          key:"name", 
          sortable: true
        },
        { 
          label: 'Date Created', 
          key:"createdAt", 
          sortable: true,
          formatter: (val) => {
            return moment(val).format('YYYY-MM-DD')
          }
        },
        {
          key:'actions',
          label:''
        }
      ],
      lang_options: [
        { value: 'all', text: 'All' },
        { value: 'jp', text: 'Japanese'},
        { value: 'us', text: 'English (US)'}
      ],
      isBusy:false,
      rowId: null
		}
	},
	computed: {
    computedEditComponent() {
      return () => import('./dialogs/edit.vue')
    },
    computedCreateComponent() {
      return () => import('./dialogs/create.vue')
    },
		rows() {
			return this.totalRows
		}
	},
	mounted() {
    this.fetchData()
	},
	methods: {
		...mapActions('role', ['paginate', 'update', 'create']),
    onSave(params) {
      var data = {}
      data.id = params.editedData._id
      let ids = []
      params.data.map(arr => {
        if(eval(arr.state.checked) == true){
          ids.push(arr.id)
        }
        if(arr.nodes) {
          ids.push(...arr.nodes.filter(x => eval(x.state.checked) == true).map(x => x.id))
          arr.nodes.map(node => {
            if(node.nodes){
              ids.push(...node.nodes.filter(x => eval(x.state.checked) == true).map(x => x.id))
            }
          })
        }
      })
      data.name = params.model.name
      data.role = params.model.role
      data.type = params.model.type
      data._id = params.model._id
      data.modules = ids
      this.update(data)
      .then(()=> {
        this.rowId = null
        this.$refs.editRole.hide()
        this.$bvToast.toast(`Role updated!`, {
          title: 'Notification',
          variant:'success'
        })
        this.fetchData()
      })
    },
    onCreate(params) {
      var data = {}
      let ids = []
      params.data.map(arr => {
        if(eval(arr.state.checked) == true){
          ids.push(arr.id)
        }
        if(arr.nodes) {
          ids.push(...arr.nodes.filter(x => eval(x.state.checked) == true).map(x => x.id))
          arr.nodes.map(node => {
            if(node.nodes){
              ids.push(...node.nodes.filter(x => eval(x.state.checked) == true).map(x => x.id))
            }
          })
        }
      })
      data.name = params.model.name
      data.role = params.model.role
      data.type = params.model.type
      data.modules = ids
      this.create(data)
      .then(()=> {
        this.$refs.createRole.hide()
        this.$bvToast.toast(`Role create!`, {
          title: 'Notification',
          variant:'success'
        })
        this.fetchData()
      })
    },
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    onEdit(val) {
      this.rowId = val
      this.$refs.editRole.show()
    },
    onShowCreate () {
      this.$refs.createRole.show()
    },
    async fetchData() {
      if(this.role_modules.some(item => item.value == 'role')){
        this.toggleBusy()

        let skip = this.currentPage <= 1 ? 0 : (this.currentPage - 1) * this.perPage
        await this.paginate({
          limit:this.perPage,
          start: skip,
          filter: this.filter,
          sort_by: this.sortBy,
          sort_desc: this.sortDesc
        })
        .then(res => {
          this.totalRows = parseInt(res.data.data.total, 10)
          this.items = res.data.data
          this.toggleBusy()
        })
      }
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },
    formatdate: function (value) {
      if (!value) return ''

      let format = 'YYYY/MM/DD hh:mm:ss A';
      return moment(value).tz('Japan').format(format)
    },
    formatStatus: function (value) {
      
      return value ? 'Success' : 'Failed'
    },
    filterList(){
      this.fetchData()
    },
    sortChange(sortValue){
      this.sortBy = sortValue.sortBy
      this.sortDesc = sortValue.sortDesc
      this.fetchData().catch(error => {
        console.error(error)
      })
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    // sortBy: {
    //   handler: function() {
    //     this.fetchData().catch(error => {
    //       console.error(error)
    //     })
    //   }
    // },
    // sortDesc: {
    //   handler: function() {
    //     this.fetchData().catch(error => {
    //       console.error(error)
    //     })
    //   }
    // },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
 .modalBodyContainer {
    background: #e8eaee;
    overflow: auto;
    height: 80vh;
  }
</style>